// hook
import useBlobURL from 'hooks/useBlobURL'
// component
import Loading from 'components/atoms/loading/loading'

const Video = props => {
	const { urlVideo } = props

	if (urlVideo.includes('vimeo') || urlVideo.includes('youtube')) {
		return (
			<div style={{ padding: '56.25% 0 0 0', position: 'relative', width: '100%' }}>
				<iframe
					src={urlVideo}
					style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
					frameBorder='0'
					allow='autoplay; fullscreen; picture-in-picture; accelerometer; gyroscope;  encrypted-media; clipboard-write'
					autoPlay
					allowFullScreen={true}
				></iframe>
			</div>
		)
	}

	if (urlVideo.includes('embed.vhx.tv')) {
		return (
			<iframe
				src={urlVideo}
				style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
				frameBorder='0 '
				webkitallowfullscreen={true}
				mozallowfullscreen={true}
				allowFullScreen={true}
			></iframe>
		)
	}

	const { isUrlBlob, isLoadBlob } = useBlobURL({ url: urlVideo })

	if (isLoadBlob) return <Loading small />
	if (!isUrlBlob) return null
	return (
		<video autoPlay allowFullScreen>
			<source src={isUrlBlob} type='video/mp4' />
		</video>
	)
}

export default Video
